<template>
  <WsMain>
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :liveSearching="true"
      :sortBy="sortBy"
      :showFields="showFields"
      :pageMode="true"
      :showExpand="false"
      :inRowBtnRead="true"
      :rowClickRead="true"
      :filterSelects="filterSelects"
      :isMultiSelect="true"
    ></WsCRUD>
  </WsMain>
</template>
<script>
import model from "@/models/organization";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: ["name", "industry_categories", "status", "updated_info"],
    liveSearching: true,
    sortBy: "sequence",
    filterSelects: [
      {
        type: "hasMany",
        label: "",
        textKey: "name",
        modelName: "industry_category",
        placeholder: "篩選產業類別",
      },
      {
        type: "switch-tabs",
        label: "",
        textKey: "name",
        modelName: "status",
        defaultValue: "1",
        items: [
          {
            value: "1",
            text: "啟用",
          },
          {
            value: "0",
            text: "停用",
          },
        ],
      },
    ],
  }),
};
</script>